module.exports = __webpack_public_path__ + "static/media/996232.24feea59.png";